import { useMutation } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IUseUpdateCategoryComponent } from "../utils/types";
import { queryClient } from "../App";

const useUpdateCategoryComponent = ({
  id,
}: {
  id: string | undefined;
}): IUseUpdateCategoryComponent =>
  useMutation({
    mutationFn: async (data: any) => {        
      const response = await AXIOS_RESERVATION.put(`v1/update-category-component/${id}`, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ["services-components"] });
    },
  });

export default useUpdateCategoryComponent;
